// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AdminPeriodController from "./admin_period_controller"
application.register("admin-period", AdminPeriodController)

import AiSetupController from "./ai_setup_controller"
application.register("ai-setup", AiSetupController)

import AutocompleteController from "./autocomplete_controller"
application.register("autocomplete", AutocompleteController)

import AutosaveController from "./autosave_controller"
application.register("autosave", AutosaveController)

import CheckAllController from "./check_all_controller"
application.register("check-all", CheckAllController)

import CollabCtaController from "./collab_cta_controller"
application.register("collab-cta", CollabCtaController)

import CustomSelectController from "./custom_select_controller"
application.register("custom-select", CustomSelectController)

import DashboardGrowthController from "./dashboard_growth_controller"
application.register("dashboard-growth", DashboardGrowthController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import GalleryController from "./gallery_controller"
application.register("gallery", GalleryController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import HoverVideoController from "./hover_video_controller"
application.register("hover-video", HoverVideoController)

import KindChipsController from "./kind_chips_controller"
application.register("kind-chips", KindChipsController)

import LightboxController from "./lightbox_controller"
application.register("lightbox", LightboxController)

import MediaModalController from "./media_modal_controller"
application.register("media-modal", MediaModalController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import PageAgentController from "./page_agent_controller"
application.register("page-agent", PageAgentController)

import PartnerModalController from "./partner_modal_controller"
application.register("partner-modal", PartnerModalController)

import PartnerOpenController from "./partner_open_controller"
application.register("partner-open", PartnerOpenController)

import PartnersMapController from "./partners_map_controller"
application.register("partners-map", PartnersMapController)

import PartnersViewController from "./partners_view_controller"
application.register("partners-view", PartnersViewController)

import PasswordStrengthController from "./password_strength_controller"
application.register("password-strength", PasswordStrengthController)

import PlaceFiltersController from "./place_filters_controller"
application.register("place-filters", PlaceFiltersController)

import PlaceMapController from "./place_map_controller"
application.register("place-map", PlaceMapController)

import PollController from "./poll_controller"
application.register("poll", PollController)

import PostGridController from "./post_grid_controller"
application.register("post-grid", PostGridController)

import ResendTimerController from "./resend_timer_controller"
application.register("resend-timer", ResendTimerController)

import ScrollFadeController from "./scroll_fade_controller"
application.register("scroll-fade", ScrollFadeController)

import SearchFormController from "./search_form_controller"
application.register("search-form", SearchFormController)

import SignupTrackingController from "./signup_tracking_controller"
application.register("signup-tracking", SignupTrackingController)

import SocialMapController from "./social_map_controller"
application.register("social-map", SocialMapController)

import SortController from "./sort_controller"
application.register("sort", SortController)

import SpotsListController from "./spots_list_controller"
application.register("spots-list", SpotsListController)

import StudioController from "./studio_controller"
application.register("studio", StudioController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import VideoStageController from "./video_stage_controller"
application.register("video-stage", VideoStageController)

import VideoSwipeController from "./video_swipe_controller"
application.register("video-swipe", VideoSwipeController)

import VocalEditorController from "./vocal_editor_controller"
application.register("vocal-editor", VocalEditorController)
